export default __webpack_public_path__ + "8a650ac716b20a411a60a03de8d97c3c.ttf";